import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme: Theme) => ({
  dropdownContainer: {
    position: 'relative'
  },
  dropdown: {
    opacity: 0,
    visibility: 'hidden',
    transition:
      'transition: transform 0.2s ease, opacity 0.2s ease, visibility 0s linear 0.2s',
    willChange: 'transform',
    position: 'absolute',
    top: '2.5rem',
    right: 0,
    marginTop: theme.spacing(3),
    zIndex: 2,
    [theme.breakpoints.only('xl')]: {
      top: '3.5rem'
    }
  },
  dropdownVisible: {
    transform: 'translateY(-0.3rem)',
    visibility: 'visible',
    opacity: 1
  }
}))
